<template>
    <v-container
        fluid
        class="primary"
        fill-height
    >
        <v-row
            align-center
            justify-center
        >
            <v-col
                class="mx-auto"
                cols="12"
                sm="8"
                md="6"
                lg="4"
                xl="2"
            >
                <v-card
                    class="primary white--text"
                    flat
                >
                    <v-card-text>
                        <v-img
                            :src="require('../../assets/imgs/trendmanager_logo_white.svg')"
                            height="40px"
                            contain
                        />
                    </v-card-text>
                    <v-card-text class="white--text">
                        <h3 class="white--text">{{ $t('pages.error.error', { code: code }) }}</h3>
                        <div class="pb-2">
                            {{ $t(message) }}
                        </div>
                        <router-link
                            class="white--text"
                            :to="{name: 'dashboard'}"
                        >
                            {{ $t('pages.error.home') }}
                        </router-link>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <div class="text-center white--text"
                     v-html="$t('pages.error.poweredby')">
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'error-page',

    props: {
        code: {
            type: String,
            default: () => '404'
        },
        message: {
            type: String,
            default: () => 'pages.error.default'
        }
    },

    metaInfo () {
        return {
            title: this.$t('pages.error.pageTitle')
        }
    }
}
</script>
